import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography,
    Divider,
    Box,
    Chip
} from '@mui/material';
import { Add as IconAdd, Category as IconCategory } from '@mui/icons-material';

const ConceptosGastoDialog = ({ open, onClose, conceptos = [], onCrearConcepto }) => {
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoAbreviado, setNuevoAbreviado] = useState('');

    const handleCrear = (e) => {
        e.preventDefault();
        if (!nuevoNombre.trim()) return;
        onCrearConcepto(nuevoNombre.trim(), nuevoAbreviado.trim());
        setNuevoNombre('');
        setNuevoAbreviado('');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold', color: '#1f2937', display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconCategory color="primary" /> Conceptos de Gastos de Caja Chica
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Catálogo oficial de conceptos clasificados para el control de rendiciones y gastos menores en todas las sedes.
                </Typography>

                {/* Formulario nuevo concepto */}
                <Box component="form" onSubmit={handleCrear} sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 1.5, mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>
                        Agregar Nuevo Concepto
                    </Typography>
                    <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={7}>
                            <TextField
                                size="small"
                                fullWidth
                                label="Nombre del Concepto"
                                placeholder="Ej: Gastos Notariales y Legalizaciones"
                                value={nuevoNombre}
                                onChange={(e) => setNuevoNombre(e.target.value)}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                size="small"
                                fullWidth
                                label="Abreviatura"
                                placeholder="Ej: Notaría"
                                value={nuevoAbreviado}
                                onChange={(e) => setNuevoAbreviado(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ height: '100%', minHeight: 40 }}
                            >
                                <IconAdd />
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Conceptos Habilitados ({conceptos.length})
                </Typography>
                <List dense sx={{ maxHeight: 250, overflowY: 'auto' }}>
                    {conceptos.map((c, idx) => (
                        <React.Fragment key={c.id}>
                            <ListItem sx={{ py: 0.75 }}>
                                <ListItemText
                                    primary={c.descripcion}
                                    secondary={c.codigo ? `Código: ${c.codigo}` : null}
                                />
                                {c.abreviado && (
                                    <Chip label={c.abreviado} size="small" variant="outlined" />
                                )}
                            </ListItem>
                            {idx < conceptos.length - 1 && <Divider component="li" />}
                        </React.Fragment>
                    ))}
                </List>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} variant="contained" color="inherit">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConceptosGastoDialog;
